import React from 'react';
import { F90K } from '../../../services/p9207Api';
import { dateToInput, approvalLabel } from '../helpers';

interface Tab2Props {
  formData: Partial<F90K>;
  names: Record<string, string>;
}

/** Page 2 — Approval info (all fields readonly per spec) */
const Tab2Approval: React.FC<Tab2Props> = React.memo(({ formData, names }) => {
  return (
    <div className="tab-content-inner">
      {/* Left column: 主管 + 人事主管 */}
      <div className="approval-grid">
        {/* 主管層級 */}
        <div className="approval-section">
          <div className="section-title">主管核准</div>
          <div className="form-grid form-grid-2col">
            <label>移交手續</label>
            <div><span className="approval-value">{approvalLabel(formData.f90k_61)}</span></div>

            <label>主管代號</label>
            <div className="lookup-field">
              <input value={String(formData.f90k_62 || '')} disabled readOnly />
              <span className="lookup-name">{names.supervisor || ''}</span>
            </div>

            <label>核准日期</label>
            <div>
              <input type="date" value={dateToInput(formData.f90k_63 as string | null)} disabled readOnly />
            </div>

            <label>核准說明</label>
            <div>
              <textarea value={String(formData.f90k_64 || '')} disabled readOnly rows={3} style={{ width: '100%' }} />
            </div>
          </div>
        </div>

        {/* 人事主管層級 */}
        <div className="approval-section">
          <div className="section-title">人事主管確認</div>
          <div className="form-grid form-grid-2col">
            <label>手續確認</label>
            <div><span className="approval-value">{approvalLabel(formData.f90k_66)}</span></div>

            <label>人事主管代號</label>
            <div className="lookup-field">
              <input value={String(formData.f90k_67 || '')} disabled readOnly />
              <span className="lookup-name">{names.hrManager || ''}</span>
            </div>

            <label>確認日期</label>
            <div>
              <input type="date" value={dateToInput(formData.f90k_68 as string | null)} disabled readOnly />
            </div>

            <label>確認說明</label>
            <div>
              <textarea value={String(formData.f90k_69 || '')} disabled readOnly rows={3} style={{ width: '100%' }} />
            </div>
          </div>
        </div>

        {/* 副總層級 */}
        <div className="approval-section">
          <div className="section-title">副總核准</div>
          <div className="form-grid form-grid-2col">
            <label>移交手續</label>
            <div><span className="approval-value">{approvalLabel(formData.f90k_71)}</span></div>

            <label>副總代號</label>
            <div className="lookup-field">
              <input value={String(formData.f90k_72 || '')} disabled readOnly />
              <span className="lookup-name">{names.vicePresident || ''}</span>
            </div>

            <label>核准日期</label>
            <div>
              <input type="date" value={dateToInput(formData.f90k_73 as string | null)} disabled readOnly />
            </div>

            <label>核准說明</label>
            <div>
              <textarea value={String(formData.f90k_74 || '')} disabled readOnly rows={3} style={{ width: '100%' }} />
            </div>
          </div>
        </div>

        {/* 總經理層級 */}
        <div className="approval-section">
          <div className="section-title">總經理核准</div>
          <div className="form-grid form-grid-2col">
            <label>移交手續</label>
            <div><span className="approval-value">{approvalLabel(formData.f90k_76)}</span></div>

            <label>總經理代號</label>
            <div className="lookup-field">
              <input value={String(formData.f90k_77 || '')} disabled readOnly />
              <span className="lookup-name">{names.president || ''}</span>
            </div>

            <label>核准日期</label>
            <div>
              <input type="date" value={dateToInput(formData.f90k_78 as string | null)} disabled readOnly />
            </div>

            <label>核准說明</label>
            <div>
              <textarea value={String(formData.f90k_79 || '')} disabled readOnly rows={3} style={{ width: '100%' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

Tab2Approval.displayName = 'Tab2Approval';
export default Tab2Approval;
